import { Box, Grid2 } from "@mui/material";
import DataCorrectionSubmitGrid from "../../../../../components/DataCorrectionSubmitGrid/DataCorrectionSubmitGrid";
import { useNavigate } from "react-router-dom";
import style from "./SubmitDataCorrection.module.css";
import { useEffect, useState } from "react";
import { getRequestedValueLabel } from "../Helper/helper";
import Loader from "../../../../../components/Loader";
import { generateUUID } from "../../../../../utilities/helper";

const SubmitDataCorrection = ({
  title,
  subjectName,
  siteName,
  description,
  id,
  handleSubmit,
  onSubmit,
  setShowSubmitPage,
  pageDescription,
  data,
  correctionData,
  load,
  isRemovedSubject = false,
}) => {
  const navigate = useNavigate();
  const [correctionTableData, setCorrectionTableData] = useState([]);

  useEffect(() => {
    if (!isRemovedSubject) {
      if (correctionData?.length > 0 && data) {
        const tempData = correctionData.map((item) => {
          const removeValue = data?.[item.removeFieldName] ?? false;

          return {
            ...item,
            requestedValue: getRequestedValueLabel(item, data),
            removeValue,
          };
        });

        // .filter((item) => !item.removeValue);

        setCorrectionTableData(tempData);
      }
    } else {
      let arr = [
        {
          answer_id: generateUUID(),
          fieldName: "The Selected Subject will be removed",
          currentValue: "Enrolled",
          requestedValue: "Removed",
        },
      ];
      setCorrectionTableData(arr);
    }
  }, [correctionData, data]);

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p className="bread-crumbs-link-container">
            <button className="bread-crumbs-btn" onClick={() => navigate("/")}>
              Home
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) => {
                navigate("/subject");
              }}
            >
              Subject Management
            </button>
            {" | "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) =>
                navigate("/update-subject", {
                  state: {
                    id: id,
                  },
                })
              }
            >
              {subjectName}
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={() => setShowSubmitPage(false)}
            >
              Data Correction
            </button>{" "}
            | <button className="bread-crumbs-btn">{title}</button>-{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>
          <Grid2
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%", margin: "0 auto" }}
          >
            <Grid2 item md={12}>
              <p className="page-heading">Submit Data Correction</p>
              <p>{description}</p>
            </Grid2>
          </Grid2>

          <Box
            component="form"
            autoComplete="off"
            sx={{ height: "auto", width: "100%" }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <Grid2
              container
              alignItems="center"
              justifyContent={"center"}
              sx={{ width: "100%", margin: "0 auto" }}
              gap={5}
            >
              <div>
                <div className={style?.containerWrapper}>
                  <div className={style?.labelWrapper}>
                    <strong>Site Name:</strong>
                  </div>
                  <div className={style?.valueWrapper}>{siteName}</div>
                </div>

                <div
                  className={`${style?.containerWrapper} ${style?.marginTop}`}
                >
                  <div className={style?.labelWrapper}>
                    <strong>Subject Name:</strong>
                  </div>
                  <div className={style?.valueWrapper}>{subjectName}</div>
                </div>

                <div
                  className={`${style?.containerWrapper} ${style?.marginTop}`}
                >
                  <div className={style?.labelWrapper}>
                    <strong>Description:</strong>
                  </div>
                  <div className={style?.valueWrapper}>{pageDescription}</div>
                </div>

                <div
                  className={`${style?.containerWrapper} ${style?.marginTop}`}
                >
                  <div className={style?.labelWrapper}>
                    <strong>Reason For Correction:</strong>
                  </div>
                  <div className={style?.labelWrapper}>{data?.reason}</div>
                </div>
              </div>
            </Grid2>

            <Grid2
              container
              alignItems="center"
              justifyContent="flex-start"
              sx={{ width: "55vw", minWidth: "61vw", margin: "20px auto" }}
            >
              <div
                style={{
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                <DataCorrectionSubmitGrid
                  tableData={correctionTableData}
                  isSubjectRemoved={isRemovedSubject}
                />
              </div>
            </Grid2>

            <Grid2
              alignItems={"end"}
              justifyContent="end"
              container
              gap={3}
              sx={{ marginTop: "2%" }}
            >
              <Grid2 item md={6}>
                <button
                  type="button"
                  className="create-btn-outlined"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSubmitPage(false);
                  }}
                >
                  Back
                </button>
              </Grid2>
              <Grid2 item md={6}>
                <button type="submit" className="create-btn">
                  Submit
                </button>
              </Grid2>
            </Grid2>
          </Box>
        </div>
      )}
    </>
  );
};

export default SubmitDataCorrection;
